export const APP = 'APP';
export const MODELS = 'MODELS';

export const ACTIVE_USER = 'ACTIVE_USER';
export const USERS = 'USERS';

// App
export const APP_ACTIVE_USER = `${APP}/${ACTIVE_USER}`;

// Models
export const MODELS_USERS = `${MODELS}/${USERS}`;
